export default {
	state: {
		activeFilters: {} // Храним все активные фильтры
	},
	mutations: {
		setActiveFilters(state, filters) {
			state.activeFilters = { ...filters };
		},
		clearActiveFilters(state) {
			state.activeFilters = {};
		}
	},
	actions: {
		updateActiveFilters({ commit }, filters) {
			commit('setActiveFilters', filters);
		},
		resetActiveFilters({ commit }) {
			commit('clearActiveFilters');
		}
	},
	getters: {
		activeFilters: state => state.activeFilters
	}
};
